import produce from 'immer';
import {State, Actions, UserRole} from './interfaces';
import {
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_FAILED,
  VERIFY_OPT,
  VERIFY_OPT_SUCCESS,
  VERIFY_OPT_FAILED,
  GENERATE_OPT,
  GENERATE_OPT_SUCCESS,
  GENERATE_OPT_FAILED,
} from './constants';

export const initialState: State = {
  token: localStorage.getItem('token'),
  role: (localStorage.getItem('role') as UserRole) || 'NONE',
  loading: false,
  error: '',
};

export const LoginReducer = (state = initialState, action: Actions) =>
  produce(state, draft => {
    switch (action.type) {
      case LOGIN:
        draft.loading = true;
        break;
      case LOGIN_SUCCESS:
        draft.token = action.data.token;
        draft.role = action.data.role;
        draft.loading = false;
        action.data && localStorage.setItem('token', action.data.token);
        action.data && localStorage.setItem('role', action.data.role);
        action.data && localStorage.setItem('name', action.data.name);
        action.data?.warehouseId &&
        localStorage.setItem('warehouseId', action.data.warehouseId);
        action.data?.partnerId && localStorage.setItem('partnerId', action.data.partnerId)
        action.data?.userId && localStorage.setItem('userId', JSON.stringify(action.data.userId))
        // action.data && localStorage.setItem('role', 'MARKETING_MANAGER');
        break;
      case LOGIN_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case VERIFY_OPT:
        draft.loading = true;
        break;
      case VERIFY_OPT_SUCCESS:
        draft.token = action.data.token;
        draft.role = action.data.role;
        draft.loading = false;
        action.data && localStorage.setItem('token', action.data.token);
        action.data && localStorage.setItem('role', action.data.role);
        break;
      case VERIFY_OPT_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GENERATE_OPT:
        draft.loading = true;
        break;
      case GENERATE_OPT_SUCCESS:
        draft.token = action.data.token;
        draft.role = action.data.role;
        draft.loading = false;
        action.data && localStorage.setItem('token', action.data.token);
        action.data && localStorage.setItem('role', action.data.role);
        break;
      case GENERATE_OPT_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      default:
        break;
    }
  });
export default LoginReducer;
